jQuery(document).ready(function ($) {
    window.arise_pc_state = window.arise_pc_state || {
        services: [],
        current_response: false,
        next_question: -1,
        all_services: [],
    };

    const state = window.arise_pc_state;

    const SECTION = '.pricing-calculator__section, .pricing-calculator__presubmission, .pricing-calculator__results';

    window.arise_pc_get_service_name = window.arise_pc_get_service_name || function (id) {
        const tile = $('#' + id);
        return tile.length ? tile.attr('title') : id;
    };

    const getServiceName = window.arise_pc_get_service_name;

    /**
     * Highlights the progress indicator for the given step (1-4) and records it on the calculator
     * so the stylesheet can react, e.g. hiding the help links on the estimate.
     */
    window.arise_pc_set_step = function (step, $context) {
        const $calculator = ($context && $context.length ? $context : $('.pricing-calculator')).closest('.pricing-calculator');

        step = parseInt(step) || 1;

        $calculator.attr('data-step', step);

        $calculator.find('.pricing-calculator__step').each(function () {
            const number = parseInt($(this).attr('data-step'));

            $(this)
                .toggleClass('is-complete', number < step)
                .toggleClass('is-active', number === step)
                .attr('aria-current', number === step ? 'step' : null);
        });
    };

    function scrollToCalculator($container) {
        $('html, body').animate({ scrollTop: $container.offset().top - ($('.heading-links').outerHeight() || 0) }, 250);
    }

    function setSelected($element, selected) {
        $element.toggleClass('selected', selected).attr('aria-checked', selected ? 'true' : 'false');
    }

    $.fn.toggleService = function () {
        setSelected(this, !this.hasClass('selected'));

        dataLayer.push({
            event: 'service_selected',
            service_name: this.attr('title')
        })

        const service_id = this.attr('id');

        const next_button = this.closest('.pricing-calculator__panel').find('.pc-next');

        if (state.services.includes(service_id)) {
            state.services = state.services.filter(function (item) {
                return item !== service_id;
            });

            if (state.services.length === 0) {
                next_button.addClass('disabled');
            }
        }
        else {
            state.services.push(service_id);

            next_button.removeClass('disabled');
        }

        this.closest('.pricing-calculator').attr('data-services', state.services.join(','));

        return this;
    }

    $.fn.toggleAnswer = function () {
        const $answers = this.closest('.pricing-calculator__answers');
        const isMultipleChoice = $answers.hasClass('pricing-calculator__answers--multiple-choice');

        if (isMultipleChoice) {
            setSelected(this, !this.hasClass('selected'));
        } else {
            setSelected(this.siblings(), false);
            setSelected(this, !this.hasClass('selected'));
        }

        const service_id = state.services[0];
        const next_button = this.closest('.pricing-calculator__panel').find('.pc-next');

        dataLayer.push({
            event: 'answer_selected',
            answer_name: this.attr('title')
        });

        if (isMultipleChoice) {
            const selectedIndices = [];
            $answers.find('.pricing-calculator__answer').each(function (i) {
                if ($(this).hasClass('selected')) {
                    selectedIndices.push(i);
                }
            });

            state.current_response = selectedIndices.length > 0
                ? `${service_id}:${state.next_question}:${selectedIndices.join(',')}`
                : false;
        } else {
            state.current_response = this.hasClass('selected')
                ? `${service_id}:${state.next_question}:${this.index()}`
                : false;
        }

        if (!state.current_response) {
            next_button.addClass('disabled');
        }
        else {
            next_button.removeClass('disabled');
        }

        return this;
    }

    $.fn.getPreviousSection = function () {
        const section = this.closest(SECTION);

        dataLayer.push({
            event: 'return_to_previous_section'
        });

        section.fadeOut(250);

        setTimeout(function () {
            const previous = section.prev();

            previous.fadeIn(250);
            window.arise_pc_set_step(previous.attr('data-step'), previous);

            section.remove();
        }, 250);
    }

    $.fn.getNextSection = function (_services, question) {
        const section = this.closest(SECTION);
        const container = section.parent();

        let next = true;

        if (section.next().length > 0) {
            next = false;
        }

        dataLayer.push({
            event: 'go_to_next_section',
            service_name: getServiceName(_services[0]),
            service_names: _services.map(getServiceName).join(', ')
        });

        const render_data = {
            services: _services.join(','),
            question: parseInt(question),
            response: state.current_response,
            next: next,
            section: section.attr('class'),

            action: 'arise_pc_get_next_section',
            nonce: arise_pc.nonce
        };

        $.ajax({
            url: arise_pc.ajax_url,
            type: 'POST',
            data: render_data,

            beforeSend: function () {
                section.addClass('loading');
            },

            success: function (response) {
                section.removeClass('loading');

                state.services = (response.data.services).split(',');
                state.next_question = parseInt(response.data.question);

                section.fadeOut(250);

                setTimeout(function () {
                    let incoming;

                    if (next) {
                        container.append(response.data.section);
                        incoming = container.children().last();
                    }
                    else {
                        incoming = section.next();
                    }

                    incoming.fadeIn(250);
                    window.arise_pc_set_step(incoming.attr('data-step'), incoming);

                    scrollToCalculator(container.closest('.pricing-calculator'));
                }, 250);
            },

            complete: function () {
                section.removeClass('loading');
            }
        });
    }

    $(document).on('click', '.pricing-calculator__answer', function (event) {
        event.preventDefault();

        $(this).toggleAnswer();
    });

    $(document).on('click', '.pricing-calculator__service', function (event) {
        event.preventDefault();

        $(this).toggleService();
    });

    $(document).on('click', '.pc-next', function (event) {
        event.preventDefault();

        if ($(this).hasClass('disabled')) {
            return;
        }

        if (state.next_question === -1) {
            state.all_services = state.services.slice();
        }

        state.next_question += 1;

        $(this).getNextSection(state.services, state.next_question);
    });

    $(document).on('click', '.pc-prev', function (event) {
        event.preventDefault();

        state.next_question -= 1;

        $(this).getPreviousSection(state.services);
    });
});
